if (!customElements.get('release-countdown')) {
  class ReleaseCountdown extends HTMLElement {
    constructor () {
      super();
      this._timerId = null;
      this._targetDate = null;
      this._elements = null;
    }

    connectedCallback () {
      this._init();
    }

    disconnectedCallback () {
      if (this._timerId) {
        clearInterval(this._timerId);
        this._timerId = null;
      }
    }

    _init () {
      if (this._timerId) {
        clearInterval(this._timerId);
        this._timerId = null;
      }
      this.innerHTML = '';

      const dayStr = this.dataset.day;
      const monthStr = this.dataset.month;
      const yearStr = this.dataset.year;

      if (!dayStr || !monthStr) {
        return;
      }

      let day = parseInt(dayStr, 10);
      let month = parseInt(monthStr, 10);

      if (Number.isNaN(day) || Number.isNaN(month)) return;
      if (day < 1 || day > 31) return;
      if (month < 1 || month > 12) return;

      const now = new Date();
      const currentYear = now.getFullYear();

      let year = parseInt(yearStr, 10);
      if (Number.isNaN(year) || year < currentYear) {
        year = currentYear;
      }

      const daysInMonth = new Date(year, month, 0).getDate();
      if (day > daysInMonth) {
        day = daysInMonth;
      }

      const target = new Date();
      target.setFullYear(year, month - 1, day);
      target.setHours(0, 0, 0, 0);

      this._targetDate = target;

      this._buildLayout(target);

      this._updateTimer();
      this._timerId = setInterval(() => this._updateTimer(), 1000);
    }

    _buildLayout (target) {
      const WEEKDAYS = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ];
      const MONTHS = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];

      const weekday = WEEKDAYS[target.getDay()];
      const monthName = MONTHS[target.getMonth()];
      const day = target.getDate();

      const dateSpan = document.createElement('span');
      dateSpan.className = 'rc-date';
      dateSpan.textContent = `${weekday}, ${monthName} ${day}`;

      const sep = document.createElement('span');
      sep.className = 'rc-separator';
      sep.textContent = ' — ';

      const timerWrapper = document.createElement('span');
      timerWrapper.className = 'rc-timer';

      const makePart = (className) => {
        const span = document.createElement('span');
        span.className = className;
        span.textContent = '00';
        return span;
      };

      const monthsEl = makePart('rc-part rc-months');
      const daysEl = makePart('rc-part rc-days');
      const hoursEl = makePart('rc-part rc-hours');
      const minutesEl = makePart('rc-part rc-minutes');
      const secondsEl = makePart('rc-part rc-seconds');

      const makeColon = () => {
        const span = document.createElement('span');
        span.className = 'rc-colon';
        span.textContent = ' : ';
        return span;
      };

      timerWrapper.append(
        monthsEl,
        makeColon(),
        daysEl,
        makeColon(),
        hoursEl,
        makeColon(),
        minutesEl,
        makeColon(),
        secondsEl,
      );

      this.append(dateSpan, sep, timerWrapper);

      this._elements = {
        monthsEl,
        daysEl,
        hoursEl,
        minutesEl,
        secondsEl,
      };
    }

    _pad2 (num) {
      return String(num).padStart(2, '0');
    }

    _getDiffComponents (from, to) {
      if (to <= from) {
        return { months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      const start = new Date(from.getTime());
      start.setMilliseconds(0);
      const end = new Date(to.getTime());
      end.setMilliseconds(0);

      let totalMonths =
        (end.getFullYear() - start.getFullYear()) * 12 +
        (end.getMonth() - start.getMonth());

      let temp = new Date(start.getTime());
      temp.setMonth(temp.getMonth() + totalMonths);

      if (temp > end) {
        totalMonths--;
        temp = new Date(start.getTime());
        temp.setMonth(temp.getMonth() + totalMonths);
      }

      const remainingMs = end - temp;
      const totalSeconds = Math.floor(remainingMs / 1000);

      const daySec = 24 * 60 * 60;
      const days = Math.floor(totalSeconds / daySec);
      let rest = totalSeconds - days * daySec;

      const hours = Math.floor(rest / 3600);
      rest -= hours * 3600;

      const minutes = Math.floor(rest / 60);
      const seconds = rest - minutes * 60;

      return {
        months: totalMonths,
        days,
        hours,
        minutes,
        seconds,
      };
    }

    _updateTimer () {
      if (!this._targetDate || !this._elements) return;

      const now = new Date();
      const diff = this._getDiffComponents(now, this._targetDate);

      const allZero =
        diff.months <= 0 &&
        diff.days <= 0 &&
        diff.hours <= 0 &&
        diff.minutes <= 0 &&
        diff.seconds <= 0;

      if (allZero) {
        this._elements.monthsEl.textContent = '00';
        this._elements.daysEl.textContent = '00';
        this._elements.hoursEl.textContent = '00';
        this._elements.minutesEl.textContent = '00';
        this._elements.secondsEl.textContent = '00';

        if (this._timerId) {
          clearInterval(this._timerId);
          this._timerId = null;
        }
        return;
      }

      this._elements.monthsEl.textContent = this._pad2(diff.months);
      this._elements.daysEl.textContent = this._pad2(diff.days);
      this._elements.hoursEl.textContent = this._pad2(diff.hours);
      this._elements.minutesEl.textContent = this._pad2(diff.minutes);
      this._elements.secondsEl.textContent = this._pad2(diff.seconds);
    }
  }

  customElements.define('release-countdown', ReleaseCountdown);
}